import { store } from "../index"

export const getToken = () => localStorage.getItem("token")

export const getEventId = () => {
  const { event } = store.getState()
  return event ? event.id : null
}

export const getDomainId = () => {
  const { event } = store.getState()
  return event ? event.client_id : null
}

export const getUserId = () => {
  const { user } = store.getState()
  return user ? user.id : null
}

export const logout = () => {
  localStorage.removeItem("token")
  window.location.pathname = `/login`
}

export function withDomainAndEvent() {
  return `domainId=${getDomainId()}${
    getEventId() ? `&eventId=${getEventId()}` : ""
  }`
}

export function withEvent() {
  return getEventId() ? `eventId=${getEventId()}` : ""
}

export const emailIsRequiredFor = (domainId: number) =>
  domainId === 5 || domainId === 168 || domainId === 155
